<template>
	<v-tabs
		:value="tab"
		:left="embedded"
		:class="{
			'rounded-b-0': embedded,
		}"
		:grow="!embedded"
		:dark="embedded && !small"
		@change="$emit('update:tab', $event)"
	>
		<v-tab
			v-for="{ title, icon, slot, disabled: tabDisabled } in tabs"
			:key="slot"
			:disabled="disabled || tabDisabled"
			:href="`#${slot}`"
			active-class="cassie-active-tab"
			class="cassie-tab text-subtitle-1"
			:class="{
				'px-10 py-5': embedded,
			}"
		>
			<v-icon
				v-if="icon"
				left
				small
				class="mr-2"
			>
				{{ icon }}
			</v-icon>
			{{ title }}
		</v-tab>
	</v-tabs>
</template>

<script>
export default {
	props: {
		tab: {
			type: String,
			required: true
		},
		tabs: {
			type: Array,
			required: true
		},
		disabled: {
			type: Boolean,
			default: false
		},
		embedded: {
			type: Boolean,
			default: false
		},
		small: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style lang="scss">
.cassie-tabs {
  box-shadow: var(--global-cassie-tabs-container-box-shadow);
}

.cassie-tab {
  border-right: var(--global-cassie-tab-border-right);
  &:nth-last-child(1) {
    border-right: none;
  }
}

.v-tabs .v-tab {
	text-transform: none;
	flex: 1 1 0 !important; /* Equal width distribution */
	max-width: none !important;
}

.v-tabs .v-tabs-bar .v-tab:not(.v-tab--active),
.v-tabs .v-tab.cassie-tab:not(.v-tab--active) {
	background-color: var(--global-tab-inactive-bg) !important;
	color: var(--global-tab-inactive-text) !important;
}

.v-tabs .cassie-active-tab,
.v-tabs .v-tab.cassie-tab.v-tab--active {
	background-color: var(--global-tab-active-bg) !important;
	color: var(--global-tab-active-text) !important;
}

.v-tabs-bar .v-tabs-bar__content .v-tabs-slider-wrapper {
	color: var(--global-primary);
}
</style>
